import { Stack, Text, Title } from "@mantine/core";

import styles from "./greeting.module.css";

export type GreetingTier = "rich" | "sparse" | "empty";

const SUBTITLE_BY_TIER: Record<GreetingTier, string> = {
    rich: "Here’s your performance snapshot for the day.",
    sparse: "Here’s where things stand today.",
    empty: "Keep up the great work! Stay focused, keep helping customers, and make every interaction count.",
};

interface Props {
    name: string;
    tier?: GreetingTier;
}

export function Greeting({ name, tier = "rich" }: Props) {
    const displayName = name.trim().length > 0 ? name : "there";

    return (
        <Stack className={styles.root} gap="sm" align="flex-start">
            <Title order={1} className={styles.heading}>
                Hi, {displayName}.
            </Title>
            <Text className={styles.subtitle}>{SUBTITLE_BY_TIER[tier]}</Text>
        </Stack>
    );
}
